export const GENERAL_PROJECTS_FILTERS_INITIAL_VALUES = {
  keywords: '',
}
